import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import FloatingHeader from './components/FloatingHeader';
import About from './pages/About';
import Footer from './components/Footer';
import PopupsPage from './pages/PopupsPage';
import TorontoForm from './pages/TorontoForm';
import MontrealForm from './pages/MontrealForm';
import VendorInfo from './pages/Vendor-Info';

function App() {
  return (
    <Router>
      <FloatingHeader />
      <Routes>
        {/* 🔁 Redirect root to /about */}
        <Route path="/" element={<Navigate to="/about-us" />} />
        <Route path="/about-us" element={<About />} />
        <Route path= "/pop-up-events" element={<PopupsPage />} />
        <Route path="/toronto-pop-up" element={<TorontoForm />} />
        <Route path="/montreal-pop-up" element={<MontrealForm />} />
        <Route path="/vendor-info" element={<VendorInfo />} />
        {/* other routes */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
